import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { httpRequest } from "../../redux/Action";
import "./Login.css";
import Loader from "../Loader";
import { toast } from "react-toastify";

function VerifyOtp() {
  const [otp, setOtp] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const email = location.state?.email;
  const number = location.state?.number;
  

  const { loading, error } =
    useSelector((state) => state.apiReducer.userVerifyOtp || {});

  const handleVerify = (e) => {
    e.preventDefault();

    dispatch(
      httpRequest({
        key: "userVerifyOtp",
        data: {
          email,
          number,
          otp,
        },

        onSuccess: (res) => {
          console.log("Login Success:", res);
          toast.success("OTP Verified! Logging you in... 🚀");

          // 🔥 redirect after login
          navigate("/user/dashboard");
        },

        onError: (err) => {
          console.log("Error:", err);
          toast.error("Invalid OTP. Please try again.");
        },
      })
    );
  };

  return (
    <div className="login-page-wrapper d-flex justify-content-center align-items-center min-vh-100 px-3">

      <div className="glass-overlay"></div>

      <div className="col-12 col-sm-10 col-md-8 col-lg-4 z-index-master">
        <form className="login-card shadow-lg" onSubmit={handleVerify}>

          <div className="text-center mb-4">
            <h3 className="fw-bold text-white mb-1">Verify OTP</h3>
            <p className="small text-white-50">
              OTP sent to <b>{email}</b>
            </p>
          </div>

  {/* {error && (
        <p style={{ color: "red" }}>
          {typeof error === "string" ? error : error?.message}
        </p>
      )} */}
          {/* OTP INPUT */}
          <div className="input-group-custom mb-4">
            <label className="small fw-bold text-white-50">Enter OTP</label>
            <input
              type="text"
              className="form-control login-input text-center"
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              maxLength={6}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-login-primary w-100 py-3 shadow"
            disabled={loading}
          >
            {loading ? (
              <Loader />
            ) : (
              "Verify & Login"
            )}
          </button>

        </form>
      </div>
    </div>
  );
}

export default VerifyOtp;